import { render, staticRenderFns } from "./EditTrustEffectiveDateDialog.vue?vue&type=template&id=096c106c"
import script from "./EditTrustEffectiveDateDialog.vue?vue&type=script&lang=js"
export * from "./EditTrustEffectiveDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports